<div class="participant-info-header">
    <div class="info-header-item">
        <span>{{ sitecore.horseRacing.raceDetails.Weight }} </span>
        <span class="header-item-value">{{ participant.properties!.weight || '-' }}</span>
    </div>
    <div class="info-header-item">
        <span>{{ sitecore.horseRacing.raceDetails.Age }} </span> <span class="header-item-value">{{ participantInfo?.horseAge || '-' }}</span>
    </div>
    <div class="info-header-item">
        <span>{{ sitecore.horseRacing.raceDetails.OR }} </span>
        <span class="header-item-value">{{ participantInfo?.preRaceMasterRating || '-' }}</span>
    </div>
    <div class="info-header-item">
        <span>{{ sitecore.horseRacing.raceDetails.EQ }} </span>
        <span class="header-item-value">{{ participantInfo?.equipmentDescription || '-' }}</span>
    </div>
</div>
